goog.provide('el8.appchart.dialog.selectPrescribingPhysician');

goog.require('el8.data.currUser');
goog.require('el8.data.physicians');
goog.require('el8.data.practiceUsers');
goog.require('el8.template.appchart.dialog.selectPrescribingPhysician');
goog.require('el8.uiwidget.Form');
goog.require('el8.uiwidget.FormDialog');
goog.require('el8.util.workspace');


el8.appchart.dialog.selectPrescribingPhysician = (function() {

    var successCb = null;

    var that = new el8.uiwidget.FormDialog({
        title: 'Select Prescribing Physician',
        autoHeight: true,
        modal: true,
        width: 400,
        contentFn: function() {
            return el8.template.appchart.dialog.selectPrescribingPhysician.content({});
        }
    });
    var form = new el8.uiwidget.Form({
        fields: [{ name: 'user', selector: ':input[name="user"]' }]
    });
    form.addButton('continue', 'Select', function() {
        successCb(form.getVal('user')*1);
        that.hide();
    }, true);
    form.addCancelButton(function() { that.hide(); }, false);
    that.setForm(form);

    var super_show = that.show;
    that.show = function(permissionType, _successCb) {
        successCb = _successCb || function() {};
        super_show.call(that);

        getDelegatingPhysicianMap(permissionType);
    };

    var super_hide = that.hide;
    that.hide = function() {
        successCb = null;
        super_hide.call(that);
        $(':input[name="user"]', that.getContentElt()).empty();
        $("body").css("cursor", "default");
    };

    function getFullNameById(arrayOfPhysicianModels, id) {
        var phys = arrayOfPhysicianModels.find(function (value) { return value.id === id; });
        return phys ? phys.full_name : "(" + id + ")";  // Always expecting to get name...
    }

    function addPhysicianOptions(usersOptData) {
        $(':input[name="user"]', that.getContentElt()).html(
            el8.template.appchart.dialog.selectPrescribingPhysician.usersList({ users: usersOptData })
        );
        $(':input[name="user"]').css("cursor", "default");
    }

    function getDelegatingPhysicianMap(permissionType) {
        var delegatingPhysicianIds;
        if (permissionType === 'rxs') {
            delegatingPhysicianIds = el8.data.currUser.getRxDelegatingPhysicianIdsInWorkspace();
        } else if (permissionType === 'orders') {
            delegatingPhysicianIds = el8.data.currUser.getOrderDelegatingPhysicianIdsInWorkspace();
        }
        $(':input[name="user"]').css("cursor", "progress");
        if (!delegatingPhysicianIds) {
            addPhysicianOptions(null);
            return;
        }

        $.el8_ajax({
            url: el8.service.urls.get('practicePhysiciansQuery'),
            type: 'GET',
            success: function (physicianListResponse) {  // create the map from IDs in FE model
                addPhysicianOptions(delegatingPhysicianIds.map(function (physicianId) {
                    return { id: physicianId, name: getFullNameById(physicianListResponse.results, physicianId) };
                }));
            },
            error: function () {  // Failed, so fall back to previous (inefficient) behavior
                addPhysicianOptions(delegatingPhysicianIds.map(function (physicianId) {
                    return { id: physicianId, name: el8.data.physicians.getById(physicianId).getFullName() };
                }));
            }
        });
    }
    return that;

})();
